import React, { useContext, useState } from 'react';
import { ButtonGroup } from 'react-bootstrap';
import {
  IoAddOutline,
  IoEyeOutline,
  IoPencilOutline,
  IoTrashBinOutline,
} from 'react-icons/io5';
import { useFormikContext } from 'formik';
import { ActionButton, Alert, DataStatus, Table } from 'components';
import { DateConvert } from 'utilities';
import { useIsGuest } from 'hooks';
import { TableDetailProduksi, ModalRealisasiProduksi } from '../../../Section';

const TablePlywood = ({
  dataPlywood,
  dataHistoryPlywood,
  dataRealisasiPlywood,
}) => {
  const isGuest = useIsGuest();
  const rootFormik = useFormikContext();
  const isReadOnly = !!rootFormik?.values?.isReadOnly;
  const [processedData, setProcessedData] = useState({});
  const [modalConfig, setModalConfig] = useState({
    show: false,
    type: 'create', // create, update atau delete
  });
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    variant: 'primary',
    text: '',
  });

  const Th = (props) => (
    <th
      {...props}
      className={`${props.className} align-middle`}
      style={{
        ...props.style,
        padding: 0,
        fontSize: '14px',
      }}
    >
      {props.children}
    </th>
  );

  const Td = (props) => (
    <td
      {...props}
      className={`${props.className} p-1`}
      style={{
        ...props.style,
        fontSize: '13px',
      }}
    >
      {props.children}
    </td>
  );

  if (isReadOnly) {
    return (
      <TableDetailProduksi
        withGudang
        title="Plywood"
        dataRealisasi={dataRealisasiPlywood}
      />
    );
  }

  return (
    <div>
      {/* Alert */}
      <Alert
        showCloseButton
        show={alertConfig.show}
        variant={alertConfig.variant}
        text={alertConfig.text}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
      />

      {/* Table List Item Plywood */}
      <div className="pb-2">
        <b className="p-1">List Item Plywood</b>
      </div>
      <Table>
        <thead className="bg-light">
          <tr>
            <Th className="py-2 text-center" style={{ width: 30 }}>
              No.
            </Th>
            <Th className="p-2 text-center" style={{ width: 100 }}>
              Tgl. Transfer
            </Th>
            <Th className="p-2 text-center" style={{ width: 100 }}>
              No. Transfer
            </Th>
            <Th className="p-2 text-center" style={{ minWidth: 300 }}>
              Item Bahan
            </Th>
            <Th className="p-2 text-center" style={{ width: 150 }}>
              Satuan
            </Th>
            <Th className="p-1 text-center" style={{ width: 100 }}>
              Qty. Transfer
            </Th>
            {!isGuest && (
              <Th className="p-0 text-center" style={{ width: 40 }}>
                Aksi
              </Th>
            )}
          </tr>
        </thead>
        <tbody>
          {dataPlywood.length > 0 ? (
            dataPlywood.map((val, index) => (
              <tr key={index}>
                <Td className="text-center">{index + 1}</Td>
                <Td>
                  {val.tgl_transfer
                    ? DateConvert(new Date(val.tgl_transfer)).defaultDMY
                    : '-'}
                </Td>
                <Td>{val.no_transfer}</Td>
                <Td>{val.nama_item}</Td>
                <Td>{val.satuan}</Td>
                <Td className="text-right">{val.qty_transfer}</Td>
                {!isGuest && (
                  <Td>
                    <ActionButton
                      size="sm"
                      className="col"
                      disable={
                        !!dataRealisasiPlywood.find(
                          (data) => data?.id_transfer === val.id_transfer
                        )
                      }
                      onClick={() => {
                        setProcessedData(val);
                        setModalConfig({
                          show: true,
                          type: 'create',
                        });
                      }}
                    >
                      <IoAddOutline />
                    </ActionButton>
                  </Td>
                )}
              </tr>
            ))
          ) : (
            <tr>
              <Td colSpan={7}>
                <DataStatus text="Tidak ada data" />
              </Td>
            </tr>
          )}
        </tbody>
      </Table>

      {/* Table List Realisasi Item Plywood */}
      <>
        <div className="mt-3 pb-2">
          <b className="p-1">Realisasi Plywood</b>
        </div>
        <Table>
          <thead className="bg-light">
            <tr>
              <Th className="py-2 text-center" style={{ width: 30 }}>
                No.
              </Th>
              <Th className="p-2 text-center" style={{ minWidth: 300 }}>
                Item Bahan
              </Th>
              <Th className="p-2 text-center" style={{ width: 150 }}>
                Satuan
              </Th>
              <Th className="p-1 text-center" style={{ width: 100 }}>
                Qty. Realisasi
              </Th>
              {!isGuest && (
                <Th className="p-0 text-center" style={{ width: 70 }}>
                  Aksi
                </Th>
              )}
            </tr>
          </thead>
          <tbody>
            {dataRealisasiPlywood.length > 0 ? (
              dataRealisasiPlywood.map((val, index) => (
                <tr key={index}>
                  <Td className="text-center">{index + 1}</Td>
                  <Td>{val.nama_item}</Td>
                  <Td>{val.satuan}</Td>
                  <Td className="text-right">{val.qty_realisasi}</Td>
                  {!isGuest && (
                    <Td>
                      <ButtonGroup size="sm">
                        <ActionButton
                          variant="success"
                          text={<IoPencilOutline />}
                          onClick={() => {
                            setProcessedData({ ...val, index });
                            setModalConfig({
                              show: true,
                              type: 'update',
                            });
                          }}
                        />
                        <ActionButton
                          variant="danger"
                          text={<IoTrashBinOutline />}
                          onClick={() => {
                            setProcessedData({ ...val, index });
                            setModalConfig({
                              show: true,
                              type: 'delete',
                            });
                          }}
                        />
                      </ButtonGroup>
                    </Td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <Td colSpan={8}>
                  <DataStatus text="Tidak ada data" />
                </Td>
              </tr>
            )}
          </tbody>
        </Table>
      </>

      {/* Table List History Item Plywood */}
      <>
        <div className="mt-3 pb-2">
          <b className="p-1">History Realisasi Plywood</b>
        </div>
        <Table>
          <thead className="bg-light">
            <tr>
              <Th className="py-2 text-center" style={{ width: 30 }}>
                No.
              </Th>
              <Th className="p-2 text-center" style={{ width: 100 }}>
                Tgl. Realisasi
              </Th>
              <Th className="p-2 text-center" style={{ width: 100 }}>
                No. Realisasi
              </Th>
              <Th className="p-2 text-center" style={{ minWidth: 300 }}>
                Item Bahan
              </Th>
              <Th className="p-2 text-center" style={{ width: 150 }}>
                Satuan
              </Th>
              <Th className="p-1 text-center" style={{ width: 100 }}>
                Qty. Realisasi
              </Th>
              <Th className="p-0 text-center" style={{ width: 40 }}>
                Aksi
              </Th>
            </tr>
          </thead>
          <tbody>
            {dataHistoryPlywood.length > 0 ? (
              dataHistoryPlywood.map((val, index) => (
                <tr key={index}>
                  <Td className="text-center">{index + 1}</Td>
                  <Td>
                    {val.tgl_realisasi
                      ? DateConvert(new Date(val.tgl_realisasi)).defaultDMY
                      : '-'}
                  </Td>
                  <Td>{val.no_realisasi}</Td>
                  <Td>{val.nama_item}</Td>
                  <Td>{val.satuan}</Td>
                  <Td className="text-right">{val.qty_realisasi}</Td>
                  <Td>
                    <ActionButton
                      variant="primary"
                      size="sm"
                      text={<IoEyeOutline />}
                      onClick={() => {
                        setProcessedData({ ...val, index });
                        setModalConfig({
                          show: true,
                          type: 'detail',
                        });
                      }}
                    />
                  </Td>
                </tr>
              ))
            ) : (
              <tr>
                <Td colSpan={8}>
                  <DataStatus text="Tidak ada data" />
                </Td>
              </tr>
            )}
          </tbody>
        </Table>
      </>

      {/* Modal Realisasi */}
      <ModalRealisasiProduksi
        withGudang
        tabKey="plywood"
        title="Plywood"
        processedData={processedData}
        modalConfig={modalConfig}
        setAlertConfig={setAlertConfig}
        setModalConfig={setModalConfig}
        setProcessedData={setProcessedData}
      />
    </div>
  );
};

export default TablePlywood;
